import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_bulb_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_bulb_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import rgbw_bulb_settings from '@devices/settings/device_settings/rgbw_bulb_settings.js';

export default {
	name: 'Hilux',
	friendly_name: 'Hilux',
	family: 'light',
	isPM: false,
	modes: {
		cct: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color_temp: { minValue: 2200, maxValue: 6000 },
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				app_setting_bulb_rgbw_gen_2,
				share,
				rgbw_bulb_settings,
			],
		},
	},
};
